// Web Hosting translations

const webhosting = {
  en: {
    webhosting: {
      title: "Web Hosting",
      subtitle: "From simple websites to private clouds – find the right plan. All packages include free SSL and DDoS protection.",
      badge_ddos: "DDoS Protection",
      badge_setup: "Instant Setup",
      badge_ssl: "Free SSL",
      badge_mysql: "MySQL Included",
      notSureTitle: "Not sure which hosting to choose?",
      notSureDesc: "Our Product Finder helps you find the perfect solution in a few steps.",
      calc_title: "Price Comparison Calculator",
      calc_subtitle: "Answer 2 questions – we'll show you the cheapest matching plan.",
      calc_step1: "What do you want to host?",
      calc_step2: "How much storage do you need?",
      calc_calculate: "Calculate Best Plan",
      calc_results: "Top recommendations for you",
      calc_bestChoice: "Best Choice",
      calc_need_website: "Website / Blog",
      calc_need_shop: "Online Shop / Web App",
      calc_need_cloud: "Private Cloud / Backup",
      calc_need_wordpress: "WordPress Site",
      calc_viewPlan: "View Plan",
      ssd_badge: "SSD Web Hosting",
      ssd_title1: "Your Website.",
      ssd_title2: "Fast & Secure.",
      ssd_desc: "SSD hosting with Plesk panel, free SSL and DDoS protection. No server knowledge required – just upload and go.",
      ssd_badge_ddos: "DDoS Protection",
      ssd_badge_ssl: "Free SSL",
      ssd_badge_setup: "Instant Setup",
      ssd_link_nvme: "NVMe (faster)",
      ssd_plansTitle: "Our SSD Hosting Plans",
      ssd_includedTitle: "Included in every plan",
      ssd_includedSubtitle: "No hidden fine print – everything you need is included.",
      ssd_wpTitle: "WordPress with one click",
      ssd_wpDesc: "Install WordPress, Joomla, PrestaShop and many more CMS systems directly via the Application Manager in Plesk – no manual setup needed.",
      ssd_ctaTitle: "Not sure which plan?",
      ssd_ctaDesc: "Our Product Finder helps you find the perfect solution in a few steps.",
      nvme_badge: "NVMe Web Hosting",
      nvme_title1: "Maximum Speed.",
      nvme_title2: "Minimum Load Times.",
      nvme_desc: "NVMe storage is significantly faster than traditional SSDs – perfect for shops, dynamic web apps and high-traffic WordPress sites.",
      nvme_badge_speed: "3x faster than SSD",
      nvme_badge_ddos: "DDoS Protection",
      nvme_badge_ssl: "Free SSL",
      nvme_link_ssd: "SSD (cheaper)",
      nvme_plansTitle: "Our NVMe Hosting Plans",
      nvme_statsTitle: "NVMe vs. SATA-SSD",
      nvme_statsSubtitle: "Why NVMe makes the difference",
      nvme_stat1_value: "3x",
      nvme_stat1_label: "Faster read speed",
      nvme_stat1_sub: "compared to SATA-SSD",
      nvme_stat2_value: "5x",
      nvme_stat2_label: "Faster write speed",
      nvme_stat2_sub: "significantly less waiting time",
      nvme_stat3_value: "10x",
      nvme_stat3_label: "Lower latency",
      nvme_stat3_sub: "for responsive web apps",
      nvme_includedTitle: "Included in every plan",
      nvme_includedSubtitle: "No hidden fine print – everything you need is included.",
      nvme_ctaTitle: "Not sure which plan fits?",
      nvme_ctaDesc: "Our Product Finder helps you find the perfect solution in a few steps.",
      nc_badge: "Nextcloud Hosting",
      nc_title1: "Your private Cloud.",
      nc_title2: "100% in Germany.",
      nc_desc: "Nextcloud pre-installed, ready to use. No Google Drive, no Dropbox – your data belongs to you and stays on German servers.",
      nc_badge_gdpr: "GDPR Compliant",
      nc_badge_privacy: "Your data only",
      nc_badge_users: "Unlimited Users",
      nc_plansTitle: "Nextcloud Server Plans",
      nc_plansSubtitle: "Prepaid, cancel monthly – as flexible as you need.",
      nc_storage: "Storage",
      nc_usecasesTitle: "What can you do with Nextcloud?",
      nc_usecasesSubtitle: "More than just file storage – a complete collaboration platform.",
      nc_faqTitle: "Frequently Asked Questions",
      nc_ctaTitle: "Privacy-first cloud storage",
      nc_ctaDesc: "Unlike Google Drive or Dropbox, your data stays on servers in Germany. Fully GDPR compliant.",
      nc_ctaBtn: "Get started from €2.49",
      nc_use_storage_title: "File Storage",
      nc_use_storage_desc: "Store documents, images and videos securely in Germany and access them from anywhere.",
      nc_use_share_title: "Share & Collaborate",
      nc_use_share_desc: "Share folders and files with family, friends or your team – with access control.",
      nc_use_office_title: "Office Suite",
      nc_use_office_desc: "Edit documents, spreadsheets and presentations directly in the browser.",
      nc_use_mobile_title: "Mobile App",
      nc_use_mobile_desc: "Free app for iOS and Android – automatically sync your photos.",
      nc_use_sync_title: "Auto-Sync",
      nc_use_sync_desc: "Desktop client for Windows/Mac/Linux automatically synchronizes your data.",
      nc_use_privacy_title: "Privacy",
      nc_use_privacy_desc: "Your data stays in Germany. No sharing with third parties. 100% GDPR compliant.",
      nc_faq_q1: "How many users can I create?",
      nc_faq_a1: "There is no user limit – except your available storage. Practically unlimited.",
      nc_faq_q2: "How does configuration work?",
      nc_faq_a2: "After payment, Nextcloud is automatically set up. You just need to add the domain under 'Trusted Domains' in the config.",
      nc_faq_q3: "Can I expand the storage?",
      nc_faq_a3: "Yes, you can switch to a larger plan at any time. Just open a support ticket.",
      nc_faq_q4: "Is my data secure?",
      nc_faq_a4: "Your data is exclusively on German servers and is never shared with third parties.",
      feat_ssl_label: "Free SSL",
      feat_ssl_desc: "Let's Encrypt SSL for all domains included",
      feat_ddos_label: "DDoS Protection",
      feat_ddos_desc: "Permanent protection against DDoS attacks",
      feat_email_label: "Email Accounts",
      feat_email_desc: "Professional email addresses with your domain",
      feat_db_label: "MySQL Databases",
      feat_db_desc: "MariaDB/MySQL for CMS, shops & web apps",
      feat_plesk_label: "Plesk Panel",
      feat_plesk_desc: "Easy management without server knowledge",
      feat_support_label: "Ticket Support",
      feat_support_desc: "Our team helps you with all questions",
    },
  },

  de: {
    webhosting: {
      title: "Web-Hosting",
      subtitle: "Von der einfachen Website bis zur privaten Cloud – finde den passenden Tarif. Alle Pakete mit kostenlosem SSL und DDoS-Schutz.",
      badge_ddos: "DDoS-Schutz",
      badge_setup: "Sofort-Setup",
      badge_ssl: "Kostenloses SSL",
      badge_mysql: "MySQL inklusive",
      notSureTitle: "Nicht sicher, welches Hosting passt?",
      notSureDesc: "Unser Produkt-Finder hilft dir in wenigen Schritten die perfekte Lösung zu finden.",
      calc_title: "Preis-Vergleichsrechner",
      calc_subtitle: "Beantworte 2 Fragen – wir zeigen dir den günstigsten passenden Tarif.",
      calc_step1: "Was möchtest du hosten?",
      calc_step2: "Wie viel Speicherplatz brauchst du?",
      calc_calculate: "Besten Tarif berechnen",
      calc_results: "Top-Empfehlungen für dich",
      calc_bestChoice: "Beste Wahl",
      calc_need_website: "Website / Blog",
      calc_need_shop: "Online-Shop / Web-App",
      calc_need_cloud: "Private Cloud / Backup",
      calc_need_wordpress: "WordPress-Seite",
      calc_viewPlan: "Tarif ansehen",
      ssd_badge: "SSD Web-Hosting",
      ssd_title1: "Deine Website.",
      ssd_title2: "Schnell & sicher.",
      ssd_desc: "SSD-Hosting mit Plesk-Panel, kostenlosem SSL und DDoS-Schutz. Keine Serverkenntnisse nötig – einfach hochladen und loslegen.",
      ssd_badge_ddos: "DDoS-Schutz",
      ssd_badge_ssl: "Kostenloses SSL",
      ssd_badge_setup: "Sofort-Setup",
      ssd_link_nvme: "NVMe (schneller)",
      ssd_plansTitle: "Unsere SSD-Hosting Tarife",
      ssd_includedTitle: "In jedem Tarif inklusive",
      ssd_includedSubtitle: "Kein verstecktes Kleingedrucktes – alles was du brauchst ist dabei.",
      ssd_wpTitle: "WordPress mit einem Klick",
      ssd_wpDesc: "Installiere WordPress, Joomla, PrestaShop und viele weitere CMS-Systeme direkt über den Application Manager im Plesk-Panel – kein manuelles Setup nötig.",
      ssd_ctaTitle: "Noch unsicher welcher Tarif passt?",
      ssd_ctaDesc: "Unser Produkt-Finder hilft dir in wenigen Schritten die perfekte Lösung zu finden.",
      nvme_badge: "NVMe Web-Hosting",
      nvme_title1: "Maximale Speed.",
      nvme_title2: "Minimale Ladezeiten.",
      nvme_desc: "NVMe-Storage ist deutlich schneller als herkömmliche SSDs – perfekt für Shops, dynamische Web-Apps und WordPress-Seiten mit hohem Traffic.",
      nvme_badge_speed: "3x schneller als SSD",
      nvme_badge_ddos: "DDoS-Schutz",
      nvme_badge_ssl: "Kostenloses SSL",
      nvme_link_ssd: "SSD (günstiger)",
      nvme_plansTitle: "Unsere NVMe-Hosting Tarife",
      nvme_statsTitle: "NVMe vs. SATA-SSD",
      nvme_statsSubtitle: "Warum NVMe den Unterschied macht",
      nvme_stat1_value: "3x",
      nvme_stat1_label: "Schnellere Lesegeschwindigkeit",
      nvme_stat1_sub: "gegenüber SATA-SSD",
      nvme_stat2_value: "5x",
      nvme_stat2_label: "Schnellere Schreibgeschwindigkeit",
      nvme_stat2_sub: "deutlich weniger Wartezeit",
      nvme_stat3_value: "10x",
      nvme_stat3_label: "Geringere Latenz",
      nvme_stat3_sub: "für reaktionsschnelle Web-Apps",
      nvme_includedTitle: "In jedem Tarif inklusive",
      nvme_includedSubtitle: "Kein verstecktes Kleingedrucktes – alles was du brauchst ist dabei.",
      nvme_ctaTitle: "Nicht sicher welcher Tarif passt?",
      nvme_ctaDesc: "Unser Produkt-Finder hilft dir in wenigen Schritten die perfekte Lösung zu finden.",
      nc_badge: "Nextcloud-Hosting",
      nc_title1: "Deine private Cloud.",
      nc_title2: "100% in Deutschland.",
      nc_desc: "Nextcloud vorinstalliert, sofort einsatzbereit. Keine Google Drive, kein Dropbox – deine Daten gehören dir und bleiben auf deutschen Servern.",
      nc_badge_gdpr: "DSGVO-konform",
      nc_badge_privacy: "Nur deine Daten",
      nc_badge_users: "Unbegrenzte Nutzer",
      nc_plansTitle: "Nextcloud Server Tarife",
      nc_plansSubtitle: "Prepaid, monatlich kündbar – so flexibel wie du es brauchst.",
      nc_storage: "Speicherplatz",
      nc_usecasesTitle: "Was kannst du mit Nextcloud machen?",
      nc_usecasesSubtitle: "Mehr als nur Datenspeicher – eine vollständige Collaboration-Plattform.",
      nc_faqTitle: "Häufige Fragen",
      nc_ctaTitle: "Datenschutz-konforme Cloud-Lösung",
      nc_ctaDesc: "Im Gegensatz zu Google Drive oder Dropbox bleiben deine Daten auf Servern in Deutschland. Vollständig DSGVO-konform.",
      nc_ctaBtn: "Jetzt starten ab €2,49",
      nc_use_storage_title: "Datei-Speicher",
      nc_use_storage_desc: "Dokumente, Bilder und Videos sicher in Deutschland speichern und von überall abrufen.",
      nc_use_share_title: "Teilen & Kollaboration",
      nc_use_share_desc: "Ordner und Dateien mit Familie, Freunden oder dem Team teilen – mit Zugangskontrolle.",
      nc_use_office_title: "Office-Suite",
      nc_use_office_desc: "Dokumente, Tabellen und Präsentationen direkt im Browser bearbeiten.",
      nc_use_mobile_title: "Mobile App",
      nc_use_mobile_desc: "Kostenlose App für iOS und Android – Fotos automatisch synchronisieren.",
      nc_use_sync_title: "Auto-Sync",
      nc_use_sync_desc: "Desktop-Client für Windows/Mac/Linux synchronisiert deine Daten automatisch.",
      nc_use_privacy_title: "Datenschutz",
      nc_use_privacy_desc: "Deine Daten bleiben in Deutschland. Keine Weitergabe an Dritte. 100% DSGVO-konform.",
      nc_faq_q1: "Wie viele Nutzer kann ich anlegen?",
      nc_faq_a1: "Es gibt kein Nutzerlimit – außer deinem verfügbaren Speicherplatz. Praktisch unbegrenzt.",
      nc_faq_q2: "Wie funktioniert die Einrichtung?",
      nc_faq_a2: "Nach Zahlungseingang wird Nextcloud automatisch aufgesetzt. Du musst nur noch die Domain unter 'Trusted Domains' in der Config eintragen.",
      nc_faq_q3: "Kann ich den Speicher erweitern?",
      nc_faq_a3: "Ja, du kannst jederzeit auf einen größeren Tarif wechseln. Einfach ein Support-Ticket öffnen.",
      nc_faq_q4: "Sind meine Daten sicher?",
      nc_faq_a4: "Deine Daten liegen ausschließlich auf deutschen Servern und werden nie an Dritte weitergegeben.",
      feat_ssl_label: "Kostenloses SSL",
      feat_ssl_desc: "Let's Encrypt SSL für alle Domains inklusive",
      feat_ddos_label: "DDoS-Schutz",
      feat_ddos_desc: "Permanenter Schutz gegen DDoS-Angriffe",
      feat_email_label: "E-Mail-Postfächer",
      feat_email_desc: "Professionelle E-Mail-Adressen mit deiner Domain",
      feat_db_label: "MySQL-Datenbanken",
      feat_db_desc: "MariaDB/MySQL für CMS, Shops & Web-Apps",
      feat_plesk_label: "Plesk-Panel",
      feat_plesk_desc: "Einfache Verwaltung ohne Server-Kenntnisse",
      feat_support_label: "Ticket Support",
      feat_support_desc: "Unser Team hilft dir bei allen Fragen weiter",
    },
  },
};

export default webhosting;
